import React, { useCallback, useEffect, useState } from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import {
    Column,
    DataGrid,
    Editing,
    Scrolling
} from 'devextreme-react/data-grid';
import { checkPermission } from '../../../permissions.js';
import { EditCellTimeComponent, TimeBoxBold } from '../../utils/time-box/TimeBox.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getApiToken } from '../../../utils/authUtils.js';
import { PerformanceCellOnlyIncrease } from '../../utils/performance-cell/PerformanceCell.js';
import { useMsal } from "@azure/msal-react";
export const EntriesClubDetails = (props) => {
      const { instance, accounts } = useMsal();
    const [entriesStore, setEntriesStore] = useState(null);
    useEffect(() => {
        if (props.data.key) {
            getApiToken(instance, accounts).then((token) => {

                setEntriesStore({
                    store: createStore({
                        key: 'entryId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Entry/Entries`,
                    
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: [['competitionId', '=', props.data.data.competitionId], ['clubId', '=', props.data.key]],
                });
              
            })
        }
    }, [props.data.key]);


    return (

        <DataGrid dataSource={entriesStore} showBorders={true} remoteOperations={true}>
            <Scrolling  mode='virtual' />
            <Column dataField="athletename" caption='Sportler' dataType='number'groupIndex={1} />
            <Column dataField="number" caption='Distanz' dataType='number' />
            <Column dataField="name" caption='Strecke'/>
            <Column dataField="entrytime" caption='Meldezeit' dataType='number' cellRender={TimeBoxBold}  />
           
            <Column dataField="groupname" caption='Trainingsgruppe' groupIndex={0} />
            <Column dataField="eventorder" visible={false} sortOrder='asc' sortIndex={1} />
        </DataGrid>


    );
};

